import { motion } from "framer-motion";

/* Simplified, recognizable brand glyphs (brand colors) */
function ChatGPTGlyph() {
  return (
    <svg viewBox="0 0 24 24" className="h-7 w-7"><path fill="#10A37F" d="M22.28 9.82a5.98 5.98 0 0 0-.52-4.91 6.05 6.05 0 0 0-6.5-2.9A6 6 0 0 0 4.98 4.18a5.98 5.98 0 0 0-4 2.9 6.05 6.05 0 0 0 .74 7.1 5.98 5.98 0 0 0 .52 4.9 6.05 6.05 0 0 0 6.5 2.9A6 6 0 0 0 19.02 19.8a5.98 5.98 0 0 0 4-2.9 6.05 6.05 0 0 0-.74-7.09Zm-9 12.6a4.48 4.48 0 0 1-2.88-1.04l.14-.08 4.78-2.76a.78.78 0 0 0 .4-.68v-6.74l2.02 1.17a.07.07 0 0 1 .04.06v5.58a4.5 4.5 0 0 1-4.5 4.49Zm-9.66-4.13a4.48 4.48 0 0 1-.54-3.01l.14.08 4.78 2.76a.78.78 0 0 0 .78 0l5.84-3.37v2.33a.07.07 0 0 1-.03.06l-4.83 2.79a4.5 4.5 0 0 1-6.14-1.64Zm-1.26-10.4a4.48 4.48 0 0 1 2.34-1.97v5.68a.78.78 0 0 0 .39.68l5.84 3.37-2.02 1.16a.07.07 0 0 1-.07 0l-4.83-2.79a4.5 4.5 0 0 1-1.65-6.11Zm16.6 3.86-5.84-3.38 2.02-1.16a.07.07 0 0 1 .07 0l4.83 2.78a4.49 4.49 0 0 1-.69 8.1v-5.67a.78.78 0 0 0-.39-.67Zm2.01-3.03-.14-.08-4.78-2.77a.78.78 0 0 0-.78 0L9.63 9.63V7.3a.07.07 0 0 1 .03-.06l4.83-2.78a4.49 4.49 0 0 1 6.67 4.65ZM8.53 12.6l-2.02-1.17a.07.07 0 0 1-.04-.06V5.8a4.49 4.49 0 0 1 7.37-3.45l-.14.08L8.92 5.2a.78.78 0 0 0-.4.68l.01 6.73Zm1.1-2.37L12.24 8.72l2.6 1.5v3l-2.6 1.5-2.6-1.5v-3Z"/></svg>
  );
}
function GeminiGlyph() {
  return (
    <svg viewBox="0 0 24 24" className="h-7 w-7"><defs><linearGradient id="gem" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stopColor="#4285F4"/><stop offset="100%" stopColor="#6E56CF"/></linearGradient></defs><path fill="url(#gem)" d="M12 2c.4 5.4 4.6 9.6 10 10-5.4.4-9.6 4.6-10 10-.4-5.4-4.6-9.6-10-10 5.4-.4 9.6-4.6 10-10Z"/></svg>
  );
}
function ClaudeGlyph() {
  return (
    <svg viewBox="0 0 24 24" className="h-7 w-7"><g fill="#D97757"><rect x="11" y="2" width="2" height="20" rx="1" transform="rotate(0 12 12)"/><rect x="11" y="2" width="2" height="20" rx="1" transform="rotate(60 12 12)"/><rect x="11" y="2" width="2" height="20" rx="1" transform="rotate(120 12 12)"/></g></svg>
  );
}
function PerplexityGlyph() {
  return (
    <svg viewBox="0 0 24 24" className="h-7 w-7" fill="none" stroke="#20808D" strokeWidth="1.6"><path d="M12 3v18M4 8l8-5 8 5v8l-8 5-8-5V8Z"/><path d="M4 8l8 5 8-5"/></svg>
  );
}

const BRANDS = [
  { name: "ChatGPT", Glyph: ChatGPTGlyph },
  { name: "Gemini", Glyph: GeminiGlyph },
  { name: "Claude", Glyph: ClaudeGlyph },
  { name: "Perplexity", Glyph: PerplexityGlyph },
];

export default function AILogosLoader() {
  return (
    <div className="flex flex-col items-center justify-center text-center py-6" data-testid="ai-logos-loader">
      <div className="flex items-center gap-4">
        {BRANDS.map((b, i) => (
          <motion.div
            key={b.name}
            className="flex flex-col items-center gap-2"
            initial={{ opacity: 0.35, scale: 0.9 }}
            animate={{ opacity: [0.35, 1, 0.35], scale: [0.9, 1.12, 0.9], y: [0, -6, 0] }}
            transition={{ duration: 1.4, repeat: Infinity, delay: i * 0.28, ease: "easeInOut" }}
          >
            <div className="h-14 w-14 rounded-2xl bg-white border border-gray-200 shadow-sm flex items-center justify-center">
              <b.Glyph />
            </div>
            <span className="text-[11px] font-medium text-gray-500">{b.name}</span>
          </motion.div>
        ))}
      </div>

      <div className="mt-8 w-56 h-1.5 rounded-full bg-gray-100 overflow-hidden">
        <motion.div
          className="h-full w-1/3 rounded-full bg-gradient-to-r from-[#0B63F6] to-[#6E56CF]"
          animate={{ x: ["-100%", "300%"] }}
          transition={{ duration: 1.3, repeat: Infinity, ease: "easeInOut" }}
        />
      </div>
      <p className="text-gray-600 mt-6 max-w-sm text-[15px]">
        Analyzing how ChatGPT, Gemini, Claude &amp; Perplexity discover, trust and cite your brand…
      </p>
    </div>
  );
}
